(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hq-slides"] && !Shopify.designMode) return;
  try {
    
  class HqSlides extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.hq-slide')];
      this.dots = [...this.querySelectorAll('.hq-dot')];
      this.i = 0;
      this.ms = Math.max(2000, parseInt(this.dataset.interval, 10) || 5000);
      this.style.setProperty('--hq-ms', this.ms + 'ms');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.slides.length < 2) return;
      this.dots.forEach((d, n) => d.addEventListener('click', () => this.go(n, true)));
      this.querySelector('.hq-prev')?.addEventListener('click', () => this.go(this.i - 1, true));
      this.querySelector('.hq-next')?.addEventListener('click', () => this.go(this.i + 1, true));
      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.resume());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.resume());
      let x = null;
      this.addEventListener('touchstart', (e) => { x = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', (e) => {
        if (x === null) return;
        const dx = e.changedTouches[0].clientX - x;
        if (Math.abs(dx) > 50) this.go(this.i + (dx < 0 ? 1 : -1), true);
        x = null;
      });
      document.addEventListener('visibilitychange', () => (document.hidden ? this.pause() : this.resume()));
      this.render();
      this.schedule();
    }
    disconnectedCallback() { clearTimeout(this.t); }
    schedule() {
      clearTimeout(this.t);
      if (this.reduced || this.paused) return;
      this.t = setTimeout(() => this.go(this.i + 1), this.ms);
    }
    pause() { this.paused = true; this.classList.add('is-paused'); clearTimeout(this.t); }
    resume() { this.paused = false; this.classList.remove('is-paused'); this.restartBar(); this.schedule(); }
    restartBar() { const d = this.dots[this.i]; if (!d) return; d.classList.remove('is-active'); void d.offsetWidth; d.classList.add('is-active'); }
    go(n, user) {
      const len = this.slides.length;
      this.i = (n + len) % len;
      this.render();
      if (user) { this.paused = false; this.classList.remove('is-paused'); }
      this.schedule();
    }
    render() {
      this.slides.forEach((s, n) => {
        const on = n === this.i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.querySelectorAll('a').forEach((a) => (a.tabIndex = on ? 0 : -1));
        const v = s.querySelector('video');
        if (v) { on ? v.play?.().catch(() => {}) : v.pause?.(); }
      });
      this.dots.forEach((d, n) => {
        d.classList.toggle('is-done', n < this.i);
        d.classList.remove('is-active');
        void d.offsetWidth;
        d.classList.toggle('is-active', n === this.i);
      });
    }
  }
  if (!customElements.get('hq-slides')) customElements.define('hq-slides', HqSlides);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
